<template>
  <div class="fld" :class="{ 'has-error': !!error }">
    <label v-if="label || $slots.label" :for="forId">
      <slot name="label">{{ label }}</slot><span v-if="required" class="req">*</span>
    </label>
    <slot />
    <div v-if="hint && !error" class="calm__form-row__hint">{{ hint }}</div>
    <div v-if="error" class="calm__form-row__error">{{ error }}</div>
  </div>
</template>

<script>
export default {
  name: "calm-field",
  props: {
    label: { type: String, default: "" },
    required: { type: Boolean, default: false },
    hint: { type: String, default: "" },
    error: { type: String, default: "" },
    forId: { type: String, default: null }, // ties <label for> to a slotted input id
  },
};
</script>

<style scoped>
/* `.req` colour for the asterisk inside a filter-bar field — the global
   .calm .fld label rule handles base label styling; only the asterisk needs
   a colour here. Namespaced; additive; does not affect existing pages. */
.fld label .req {
  color: var(--c-danger, #c0573e);
  margin-left: 2px;
}
.fld.has-error >>> .ed,
.fld.has-error >>> .el-input__inner {
  border-color: var(--c-danger, #c0573e);
}
</style>
